module.exports = __webpack_public_path__ + "static/media/sologo_new.8a6f5405.png";